<template>
    <div class="main">
        <v-container fluid class="pa-0">
            <v-card class="d-flex ml-2 pa-2 flex-row" outlined>
                <div>
                    <v-btn class="ma-2 min" small tile color="accent" dark @click="SetStatesPosition">
                        Vista de Comunidades
                        <br />autónomas
                    </v-btn>
                    <v-btn class="ma-2 min" small tile color="accent" dark @click="SetProvincePosition">Vista de Provincias</v-btn>
                    <v-btn class="ma-2 min" small tile color="accent" dark @click="SetDistrictsPosition">Vista de Municipios</v-btn>

                </div>
            </v-card>
        </v-container>
        <v-dialog persistent v-model="dialog" max-width="350">
            <v-card class="mx-auto">
                <v-toolbar color="blue" dark>
                    <v-toolbar-title>{{ this.codigo }} {{ this.markerData[Object.keys(this.markerData)[0]] }}</v-toolbar-title>
                </v-toolbar>
                <v-card-text class="pb-0">
                    <v-row>
                        <v-col sm="12" v-for="(value, name, index) in markerData" v-bind:key="index">
                            <span class="subtitle-1" v-if="index > 0">
                                <strong>{{ name }}:</strong> {{ value || '-' }}<br>
                            </span>
                        </v-col>
                    </v-row>

                </v-card-text>
                <v-card-actions class="px-6 pb-6">
                    <v-btn text small color="blue" @click="closeDialog">
                        Cerrar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text small color="blue" @click="redirectToGlobal">
                        Ir a la instalación
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <div class="d-flex ">
            <v-btn class="ma-2" small color="accent" dark @click="createPDF">
                PDF
                <v-icon dark right>mdi-adobe-acrobat</v-icon>
            </v-btn>
        </div>
        <v-container fluid class="pa-0">
            <v-card class="d-flex ml-2 mt-1 pa-2 flex-row" style="height:60vh;" outlined>
                <GmapMap style="width: 100%; height: 100%;" :zoom="zoom" :center="{lat: cLat, lng: cLng}" ref="map" :options="mapOptions">
                    <GmapCluster>
                        <GmapMarker v-for="(marker, index) in markers"
                                    :key="index"
                                    :position="marker.latLng"
                                    :clickable="true"
                                    @click="clickMarker(marker)"
                                    :icon="getImage(marker)" />
                    </GmapCluster>
                </GmapMap>
            </v-card>
        </v-container>
    </div>
</template>

<script>
    import {
        Component,
        Prop,
        Vue
    } from "vue-property-decorator";
    import GmapCluster from 'vue2-google-maps/src/components/cluster'
    import InstalationService from "../services/InstalationsService";
    import InstalationModel from "../models/InstalationModel";
    import jsPDF from 'jspdf';
    import html2canvas from 'html2canvas';
    import 'rasterizehtml';
    import CompanyService from "../services/CompanyService";


    @Component({
        components: {
            GmapCluster
        }
    })
    export default class MapaInstalaciones extends Vue {
        mounted() {
            this.loadData();
        }

        nombreArchivoPDF = "Instalaciones_Principal";
        tituloMapaPDF = " - Mapa de Instalaciones | Vista Principal ";
        dialog = false;
        cLat = 0;
        cLng = 0;
        zoom = 15;
        defaultPoint = {};
        districtPoint = {};
        provincePoint = {};
        statesPoint = {};
        companies = [];
        iconList = [];
        markers = [];
        marker = new InstalationModel();
        markerData = {};
        codigo = '';
        mapOptions = {
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: true,
            disableDefaultUi: false,
            styles: [{
                'featureType': 'poi',
                'stylers': [
                    {
                        'visibility': 'off'
                    }
                ]
            }]
        };

        async loadData() {
            this.markers = [];
            var data;
            var resMD = await new InstalationService().getmapadata({});
            if (resMD.success) {
                data = resMD.data;
            }
            else {
                this.showError('Ocurrio un error: ' + resMD.Message);
                return;
            }

            var resultComp = await new CompanyService().list({});
            if (resultComp.success) {
                this.companies = resultComp.data;
            }
            else {
                this.showError('Ocurrio un error: ' + resultComp.Message);
            }

            await this.getIcons();
            this.districtPoint = data.districtPoint;
            this.provincePoint = data.provincePoint;
            this.statesPoint = data.statesPoint;

            if (data.defaultPoint) {
                this.cLat = data.defaultPoint.fldNLatitud;
                this.cLng = data.defaultPoint.fldNLongitud;
                this.zoom = data.defaultPoint.fldNZoom;
            }
            let dataMarkers = data.data.filter((v) => {
                if (v.fldNLatitud && v.fldNLongitud)
                    return v;
            });
            this.markers = dataMarkers.map(v => {
                return {
                    ...v,
                    latLng: {
                        lat: parseFloat(v.fldNLatitud),
                        lng: parseFloat(v.fldNLongitud)
                    }
                };
            });
        }

        async getIcons() {
            var data = this.$store.getters.getIconList;
            if (data == null) {
                await this.$store.dispatch('loadIconList');
                data = this.$store.getters.getIconList;
            }
            this.iconList = data;
        }

        getImage(marker) {
            switch (marker.fldNEstado) {
                case 1:
                    return 'http://maps.google.com/mapfiles/ms/icons/green-dot.png';
                case 2:
                    return 'http://maps.google.com/mapfiles/ms/icons/yellow-dot.png';
                case 3:
                    return 'http://maps.google.com/mapfiles/ms/icons/red-dot.png';
            }
            return 'http://maps.google.com/mapfiles/ms/icons/green-dot.png';
        }

        async createPDF() {
            //var element2 = this.$refs['map'].$mapObject.mapUrl;
            var element = await document.querySelector('.vue-map-container');

            var pdfOptions = {
                orientation: "landscape", // One of "portrait" or "landscape" (or shortcuts "p" (Default), "l")
                unit: "mm",               // Measurement unit to be used when coordinates are specified. One of "pt" (points), "mm" (Default), "cm", "in"
                format: "a4"              // One of 'a3', 'a4' (Default),'a5' ,'letter' ,'legal'
            };
            const today = new Date();
            // Creamos el pdf
            var doc = new jsPDF(pdfOptions);
            // Seteamos el Titulo
            doc.text(today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear() + this.tituloMapaPDF, 10, 15);

            var pageWidth = doc.internal.pageSize.width - 20;
            var pageHeight = doc.internal.pageSize.height - 20;

            html2canvas(element, {
                useCORS: true
            }).then(canvas => {
                var imgWidth = canvas.width;
                var imgHeight = canvas.height;
                // Height alternativo
                var height = (pageWidth * imgHeight) / imgWidth
                var imgData = canvas.toDataURL('image/png');
                // Agregamos el mapa
                doc.addImage(imgData, 'PNG', 10, 25, pageWidth, height);
                doc.save(this.nombreArchivoPDF + '.pdf');
                // document.body.appendChild(canvas);
            });
        }

        async clickMarker(item) {
            this.marker = item;
            //this.markerData = await new InstalationService().getDescriptions(item.idNInstalacion);
            var res = await new InstalationService().getDescriptions(item.idNInstalacion);
            if (res.success == false) {
                this.showError(res.error);
                return;
            }
            this.markerData = res.descriptions;
            this.codigo = res.codigo;
            this.dialog = true;
        }

        closeDialog() {
            this.dialog = false;
        }

        redirectToGlobal() {
            let routeData = this.$router.resolve({
                name: 'InstalacionesGlobal',
                params: {
                    id: this.marker.idNInstalacion
                }
            });
            window.open(routeData.href, '_blank');
        }

        async SetProvincePosition() {
            await this.loadData();
            this.nombreArchivoPDF = "Instalaciones_Provincias";
            this.tituloMapaPDF = " - Mapa de Instalaciones | Vista de Provincias";
            this.cLat = parseFloat(this.provincePoint.fldNLatitud);
            this.cLng = parseFloat(this.provincePoint.fldNLongitud);
            this.zoom = parseFloat(this.provincePoint.fldNZoom);
        }

        async SetStatesPosition() {
            await this.loadData();
            this.nombreArchivoPDF = "Instalaciones_Comunidades_autónomas";
            this.tituloMapaPDF = " - Mapa de Instalaciones | Vista de Comunidades Autónomas ";
            this.cLat = parseFloat(this.statesPoint.fldNLatitud);
            this.cLng = parseFloat(this.statesPoint.fldNLongitud);
            this.zoom = parseFloat(this.statesPoint.fldNZoom);
        }

        async SetDistrictsPosition() {
            await this.loadData();
            this.nombreArchivoPDF = "Instalaciones_Municipios";
            this.tituloMapaPDF = " - Mapa de Instalaciones | Vista de Municipios";
            this.cLat = parseFloat(this.districtPoint.fldNLatitud);
            this.cLng = parseFloat(this.districtPoint.fldNLongitud);
            this.zoom = parseFloat(this.districtPoint.fldNZoom);
        }

    }
</script>
